import { Route } from '@angular/router';
import {
  buildPortalDashboardChildRoutes,
  buildPortalPermissionGuard,
  getPortalDefaultChildPath,
} from '@dlap-ui/shared-forms/shell/portal-shell/portal-shell';
import { authGuard } from '@dlap-ui/core';
import type { PortalAccessConfig } from '@dlap-ui/shared-forms/auth/otp-form/otp-form';
import { environment } from '../environments/environment';
import { BANK_PORTAL_CONFIG } from './pages/dashboard-layout/portal.config';

const dashboardChildRoutes: Route[] = buildPortalDashboardChildRoutes(BANK_PORTAL_CONFIG);

const BANK_PORTAL_ACCESS: PortalAccessConfig = {
  allowedCategories: ['Bank', 'Bond Holding'],
  categoryRedirects: {
    deeds: environment.portalUrls.deeds,
    'law firm': environment.portalUrls.lawFirm,
    'high court': environment.portalUrls.highCourt,
  },
  unauthorizedMessage: 'Not allowed to use this portal.',
};

export const appRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./pages/landing/landing').then((m) => m.Landing),
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./pages/legal/privacy-policy/privacy-policy').then((m) => m.PrivacyPolicy),
  },
  {
    path: 'terms',
    loadComponent: () => import('./pages/legal/terms/terms').then((m) => m.Terms),
  },
  {
    path: 'accessibility',
    loadComponent: () => import('./pages/legal/accessibility/accessibility').then((m) => m.Accessibility),
  },
  {
    path: 'auth',
    loadComponent: () =>
      import('./pages/auth-layout/auth-layout').then((m) => m.AuthLayout),
    children: [
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/login/login').then((m) => m.Login),
      },
      {
        path: 'otp',
        data: {
          production: environment.production,
          portalAccess: BANK_PORTAL_ACCESS,
        },
        loadComponent: () =>
          import('@dlap-ui/shared-forms/auth/otp-form/otp-form').then((m) => m.OtpForm),
      },
      {
        path: 'forgot-password',
        loadComponent: () =>
          import('@dlap-ui/shared-forms/auth/forgot-password-form/forgot-password-form').then((m) => m.ForgotPasswordForm),
      },
      {
        path: 'reset-password',
        loadComponent: () =>
          import('@dlap-ui/shared-forms/auth/reset-password-form/reset-password-form').then((m) => m.ResetPasswordForm),
      },
      { path: '', redirectTo: 'login', pathMatch: 'full' },
    ],
  },
  {
    path: 'overview',
    loadComponent: () =>
      import('./pages/dashboard-layout/dashboard-layout').then(
        (m) => m.DashboardLayout,
      ),
    canActivate: [authGuard],
    children: [
      ...dashboardChildRoutes,
      {
        path: 'apply',
        loadComponent: () =>
          import('./pages/apply/application-workflow/application-workflow').then(
            (m) => m.ApplicationWorkflow,
          ),
        canActivate: buildPortalPermissionGuard(BANK_PORTAL_CONFIG, 'applications'),
      },
      { path: '', redirectTo: getPortalDefaultChildPath(BANK_PORTAL_CONFIG), pathMatch: 'full' },
    ],
  },
];
